import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import A from "./a.jpg";
import Stack from "react-bootstrap/Stack";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ConfirmDialog from "../../common/ConfirmDialog";
import { Spinner } from "react-bootstrap";
import { LoginService, PatientService } from "../../../services";
import { LanguageContext } from "../../../utils/Language";
import './ActionDetail.css'
import ImageCarousel from "./ImageCarousel";
import ActionDetailToolbar from "../../Navbar/ActionDetailToolbar";
import { Toast, ToastContainer } from "react-bootstrap";

function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}

function ActionDetail(props) {
  const [conversation, setConversation] = useState([]);
  const [simLink, setSimLink] = useState("");
  const [planFile, setPlanFile] = useState("");
  const [images, setImages] = useState([]);
  const params = useParams();
  const { state } = useLocation();
  const [note, setNote] = useState("");
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmBody, setConfirmBody] = useState("");
  const [acceptData, setAcceptData] = useState({});
  const [showSpinner, setShowSpinner] = useState(false);
  const [showImageCarousel, setShowImageCarousel] = useState(false);
  const [imageCarouselIndex, setImageCarouselIndex] = useState(0);
  const [leftOffCanvasShow, setLeftOffCanvasShow] = useState(false);
  const [rightOffCanvasShow, setRightOffCanvasShow] = useState(true);
  const { dictionary } = useContext(LanguageContext);
  const [showMessage, setShowMessage] = useState(false)
  const [resultMessage, setResultMessage] = useState("")
  const user = LoginService.getUser();

  const downloadPDFFile = (fileUrl, filename) => {
    PatientService.downloadFile(fileUrl).then((response) => {
      console.log("download completed");
      // create file link in browser's memory
      const href = URL.createObjectURL(response);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });

  };

  const onAccept = () => {
    console.log("onAccept");
    console.log(acceptData);

    if (acceptData.type == "revision") {
      setShowSpinner(true);
      console.log("send to revision: ", state.actionId);
      sendToRevision(state.actionId)
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          console.log(data);
          return timeout(3000);
        })
        .finally(() => {
          console.log("finally");
          setShowSpinner(false);
          navigate(-1);
        });
    } else if (acceptData.type == "approval") {
      setShowSpinner(true);
      console.log("approved: ", state.actionId);
      approvePlan(state.actionId)
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          console.log(data);
          return timeout(3000);
        })
        .finally(() => {
          setShowSpinner(false);
          navigate(-1);
        });
    }
  };

  const onCancel = () => {
    setAcceptData({});
    setShowConfirm(false);
  };

  async function sendToRevision(actionId) {
    return PatientService.sendToRevision(actionId, note);
  }

  async function approvePlan(actionId) {
    return PatientService.approvePlan(actionId, note);
  }

  useEffect(() => {
    console.log(state)
    let cargoId = "";
    PatientService.getPlanDetail(params.Id).then((json) => {
      const firstElement = json.shift();
      setSimLink(firstElement.SimLink);
      setPlanFile(firstElement.PlanFile)
      cargoId = firstElement.CargoId;
      setConversation(json.reverse());

      console.log("new cargo id: ", cargoId);
      PatientService.getImageSet(cargoId).then((json) => {
        const imgs = [];
        Object.keys(json[0]).map((i) => {
          if (i.includes("Img") == true) {
            if (json[0][i]) imgs.push(json[0][i]);
          }
        });

        console.log(imgs);
        setImages(imgs);
      });
    });

    return () => {};
  }, []);

  const showCarousel = (index) => {
    setImageCarouselIndex(index)
    setShowImageCarousel(true)
  }

  const toggleCanvas = (side) => {
    if (side==='left') {
      setLeftOffCanvasShow(!leftOffCanvasShow)
    } else {
      setRightOffCanvasShow(!rightOffCanvasShow)
    }
  }

  function onDownloadTreatment() {
    if (planFile == "") {
      setResultMessage("Treatment file of this patient is not uploaded yet.")
      setShowMessage(true)
      return;
    }


      setResultMessage("Your treatment file will be downloaded shortly")
      setShowMessage(true)
    const link = `https://service.orthomagic.com.tr:8447/OrthoMagic/GetImage?ImageId=${planFile}&GUID=${user.SessionGUID}&UserId=${user.UserId}`;
    downloadPDFFile(link, state.PatientCode + ".pdf")

  }


  return (
    <>
      <Container fluid>
        <ActionDetailToolbar
          patientName={state.FirstName + " " + state.FamilyName}
          onLeftToggle={()=>toggleCanvas('left')}
          onRightToggle={()=>toggleCanvas('right')}
          onDownloadTreatmentPlan={onDownloadTreatment}
          onShareSimulation={() => {
            const index = simLink.indexOf("Client")
            const link = window.location.host + "/simulation?l=" + simLink.slice(index)
            navigator.clipboard.writeText(link)
            setResultMessage("Your simulation link copied to clipboard")
            setShowMessage(true)
            }}/>

        {showImageCarousel && <ImageCarousel index={imageCarouselIndex} images={images} onClose={()=>setShowImageCarousel(false)}/>}
        <Row>
          <Offcanvas scroll={true} backdrop={false} show={leftOffCanvasShow} onHide={()=>toggleCanvas('left')} >
            <Offcanvas.Header closeButton/>
            <Offcanvas.Body>
              <Col
                className="d-none d-md-block"
                style={{
                  position: "relative",
                }}
              >
                <Stack gap="1" style={{ overflowY: "auto", height: "100%" }}>
                  {images.map((imageId, index) => {
                    const imageURL = `https://service.orthomagic.com.tr:8447/OrthoMagic/GetImage?ImageId=TN-${imageId}&GUID=${user.SessionGUID}&UserId=${user.UserId}`;
                    return (
                      <div className="left-pane-item py-2">
                        <Button
                          variant="secondary"
                          className="open-image-button"
                          onClick={()=>{showCarousel(index)}}
                        >
                          <i className="fa fa-search-plus"></i>
                        </Button>
                        <Image key={imageId} src={imageURL} />
                      </div>
                    )
                  })}
                </Stack>
              </Col>
            </Offcanvas.Body>
          </Offcanvas>
          <Col lg>
            {/* <Col lg style={{ background: "green" }}> */}
            <div className="embed-responsive embed-responsive-4by3">
              {
                <iframe
                  id="iframe"
                  className="col-lg-12"
                  src={simLink}
                ></iframe>
              }
            </div>
          </Col>

          <Offcanvas placement='end' scroll={true} backdrop={false} show={rightOffCanvasShow} onHide={()=>toggleCanvas('right')} >
            <Offcanvas.Header closeButton/>
            <Offcanvas.Body>
              <Col
                className="h-100 d-none d-md-block"
                style={{ position: "relative" }}
              >
                {/* <Col lg={3}> */}
                <Stack gap="1" style={{ overflowY: "auto", height: "70vh" }}>
                  {conversation.map((item) => {
                    const isDoctor = user.UserId == item.UserId;
                    const userName = isDoctor ? dictionary.Doctor : "OrthoMagic";
                    return (
                      <Card key={item.Id}>
                        <Card.Header>
                          <OverlayTrigger
                            placement="left"
                            overlay={
                              <Tooltip className="d-none d-lg-block">
                                {item.SystemDate}
                              </Tooltip>
                            }
                          >
                            <Stack direction="horizontal">
                              <div>{userName}</div>
                              <div className="ms-auto text-muted d-none d-lg-block">
                                {item.SystemDate.split(" ")[0]}
                              </div>
                              <div className="ms-auto text-muted d-lg-none">
                                {item.SystemDate}
                              </div>
                            </Stack>
                          </OverlayTrigger>
                        </Card.Header>
                        <Card.Body>{item.Note}</Card.Body>
                      </Card>
                    );
                  })}
                  <Form
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      left: "0px",
                      bottom: "10px",
                      right: "0px",
                    }}
                  >
                    {!state.readonly && (
                      <div>
                        <Form.Group className="mb-3">
                          <Form.Label>Write a message</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={(e) => setNote(e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="primary"
                          className="w-100 m-1"
                          onClick={() => {
                            setConfirmTitle(dictionary.SendToRevision);
                            setConfirmBody(dictionary.SendToRevisionQuestion);
                            setShowConfirm(true);
                            setAcceptData({ type: "revision" });
                          }}
                        >
                          Send to revision
                        </Button>
                        <Button
                          variant="success"
                          className="w-100 m-1"
                          onClick={() => {
                            setConfirmTitle(dictionary.ApprovePlan);
                            setConfirmBody(dictionary.ApprovePlanQuestion);
                            setShowConfirm(true);
                            setAcceptData({ type: "approval" });
                          }}
                        >
                          Approve plan
                        </Button>
                      </div>
                    )}
                    <Button 
                      variant="danger"
                      className="w-100 m-1"
                      onClick={() => navigate(-1)}
                    >
                      {dictionary.GoBack}
                    </Button>
                  </Form>
                </Stack>
              </Col>

            </Offcanvas.Body>
          </Offcanvas>
        </Row>
        <ConfirmDialog 
          show={showConfirm}
          messageTitle={confirmTitle}
          messageBody={confirmBody}
          handleCancel={onCancel}
          handleAccept={onAccept}
        ></ConfirmDialog>
        {showSpinner && (
          <Spinner
            animation="border"
            role="status"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
            }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </Container>

      <ToastContainer className="mb-5 position-fixed" position="top-center">
        <Toast
          onClose={() => setShowMessage(false)}
          show={showMessage}
          delay={3000}
          autohide
        >
          <Toast.Body>{resultMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default ActionDetail;
